import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";

import CompleteAdminProfile from "./modules/admin/pages/completeAdminProfile";

import InvoiceDesign from "./modules/admin/pages/invoiceDesign";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import WebsiteContactUs from "./modules/website/pages/websiteContactUs";
import Page404 from "./modules/website/pages/Page404";
import ComingSoon from "./modules/website/pages/ComingSoon";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQView from "./modules/admin/pages/cms/faq/view";
import ContactUsTable from "./modules/admin/pages/contactUs/list";
import ViewContactUs from "./modules/admin/pages/contactUs/view";
import InquiryTable from "./modules/admin/pages/inquiry/list";
import ViewInquiry from "./modules/admin/pages/inquiry/view";
import UserTable from "./modules/admin/pages/user/list";
import UserView from "./modules/admin/pages/user/view";
import DynamicWebPage from "./modules/website/pages/dynamicPage";
import UserEdit from "./modules/admin/pages/user/edit";
import AboutUsAdd from "./modules/admin/pages/cms/aboutUs/add";
import SubscriptionPlanTable from "./modules/admin/pages/subscriptionPlan/list";
import AddSubscriptionPlan from "./modules/admin/pages/subscriptionPlan/add";
import EditSubscriptionPlan from "./modules/admin/pages/subscriptionPlan/edit";
import SubscriptionPlanView from "./modules/admin/pages/subscriptionPlan/view";
import SubscriptionFeature from "./modules/admin/pages/subscription/subscriptionFeatures";
import ServiceTable from "./modules/admin/pages/cms/services/list";
import ServiceAdd from "./modules/admin/pages/cms/services/add";
import ServiceEdit from "./modules/admin/pages/cms/services/edit";
import ServiceView from "./modules/admin/pages/cms/services/view";
import LanguageTable from "./modules/admin/pages/cms/languages/list";
import LanguageAdd from "./modules/admin/pages/cms/languages/add";
import LanguageEdit from "./modules/admin/pages/cms/languages/edit";
import LanguageView from "./modules/admin/pages/cms/languages/view";
import WebsiteHomeAdd from "./modules/admin/pages/cms/home/add";
import SubscriptionBenefit from "./modules/admin/pages/subscription/subscriptionBenefit";
import AstrologerUserTable from "./modules/admin/pages/astrologer/list";
import AstrologerView from "./modules/admin/pages/astrologer/view";
import AstrologerAdd from "./modules/admin/pages/astrologer/add";
import AstrologerEdit from "./modules/admin/pages/astrologer/edit";
import UserPrivateRoute from "./modules/user/shared/UserPrivateRoute";
import UserLayout from "./modules/user/shared/layout";
import UserHomeFront from "./modules/user";
import UserPublicRoute from "./modules/user/shared/UserPublicRoute";
import UserAuthLayout from "./modules/user/shared/UserAuthLayout";
import UserLogin from "./modules/user/pages/auth/UserLogin";
import ForgetPassword from "./modules/user/pages/auth/ForgetPassword";
import UserFrontLayout from "./modules/user/shared/UserFrontLayout";
import UserHeader from "./modules/user/shared/header";
import UserFooter from "./modules/user/shared/footer";
import ResetPassword from "./modules/user/pages/auth/ResetPassword";
import UserSignUp from "./modules/user/pages/auth/UserSignUp";
import ProfileSetup from "./modules/user/pages/auth/ProfileSetup";
import UserDashborad from "./modules/user/pages/dashborad/dashborad";
import Search from "./modules/user/pages/dashborad/search";
import Notifications from "./modules/user/pages/dashborad/notifications";
import Horoscope from "./modules/user/pages/dashborad/horoscope";
import Numerology from "./modules/user/pages/dashborad/numerology";
import KundliMatching from "./modules/user/pages/dashborad/kundliMatching";
import ChatInterface from "./modules/admin/pages/chat/ChatInterface";
import KundliMatchingDetail from "./modules/user/pages/dashborad/kundliMatching/Detail";
import MyKundli from "./modules/user/pages/dashborad/MyKundli";
import UserAdd from "./modules/admin/pages/user/add";
import AddRemedy from "./modules/admin/pages/remedies/AddRemedy";
import RemedyList from "./modules/admin/pages/remedies/RemedyList";
import EditRemedy from "./modules/admin/pages/remedies/EditRemedy";
import ViewRemedy from "./modules/admin/pages/remedies/ViewRemedy";
import FeedbackTable from "./modules/admin/pages/feedback/list";
import FeedbackView from "./modules/admin/pages/feedback/view";
import BookingTable from "./modules/admin/pages/booking/list";
import OfferManagementAdd from "./modules/admin/pages/cms/offerManagement/ OfferManagementAdd";
import LiveConsultationMonitor from "./modules/admin/pages/LiveConsultation/LiveConsultationMonitor";
import CallLogsPage from "./modules/admin/pages/astrologer/CallLogsPage";
import RevenueDashboard from "./modules/admin/pages/dashboard/RevenueDashboard";
import ListLearnHub from "./modules/admin/pages/cms/learn-hub/list";
import AddLearnHub from "./modules/admin/pages/cms/learn-hub/add";
import EditLearnHub from "./modules/admin/pages/cms/learn-hub/edit";
import ViewLearnHub from "./modules/admin/pages/cms/learn-hub/view";
import WithdrawalList from "./modules/admin/pages/withdrawal/WithdrawalList";
import PujaBookingsList from "./modules/admin/pages/pujaBooking/PujaBookingsList";
import PujaBookingsList1 from "./modules/admin/pages/pujaBooking/PujaBookingsList1";
import OrderList from "./modules/admin/pages/order/OrderList";
import OrderView from "./modules/admin/pages/order/OrderView";
import ReportsAnalytics from "./modules/admin/pages/dashboard/ReportsAnalytics";
import AdminEmailAnnouncement from "./modules/admin/pages/cms/Announcement/AdminSendAnnouncement";
import AdminNotificationAnnouncement from "./modules/admin/pages/cms/Announcement/AdminNotificationAnnouncement";

const Public404 = () => (
  <div className="site-bg">
    <UserHeader />
    <div className="inner-wraper">
      <Page404 />
    </div>
    <UserFooter />
  </div>
);

const router = createBrowserRouter([
  // Home front & Public Pages
  {
    path: "",
    element: <UserPublicRoute component={UserFrontLayout} />,
    children: [
      {
        path: "",
        element: <UserPublicRoute component={UserHomeFront} />,
      },
      {
        path: "faq",
        element: <UserPublicRoute component={UserHomeFront} />,
      },
      {
        path: "about",
        element: <DynamicWebPage defaultSlug="user-about-us" />,
      },
      {
        path: "privacy",
        element: <DynamicWebPage defaultSlug="user-privacy-policy" />,
      },
      {
        path: "terms",
        element: <DynamicWebPage defaultSlug="user-terms-service" />,
      },
      {
        path: "contact",
        element: <WebsiteContactUs />,
      },
      {
        path: "coming-soon",
        element: <ComingSoon />,
      },
      {
        path: "services",
        element: (
          <ComingSoon
            title="Astrology Services"
            badge="Services Coming Soon"
            description="Our verified Vedic astrologers offer comprehensive horoscope readings, Kundli matching, and life guidance consultations. This dedicated service portal is launching soon in the next phase."
          />
        ),
      },
      {
        path: "remedies-store",
        element: (
          <ComingSoon
            title="Spiritual Remedies Store"
            badge="Remedies Store Coming Soon"
            description="Explore 100% authentic energized gemstones, certified rudraksha beads, sacred yantras, and customized pujas. Our online spiritual store will open in the next phase."
          />
        ),
      },
      {
        path: "download-app",
        element: <UserPublicRoute component={UserHomeFront} />,
      },
      {
        path: "page/:slug",
        element: <DynamicWebPage />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
    ],
  },

  // App WebView Route (for Google Play Store / In-App WebView)
  {
    path: "org-info/:slug",
    element: <DynamicWebPage />,
  },

  //  user auth start
  {
    path: "",
    element: <UserPublicRoute component={UserAuthLayout} />,
    children: [
      {
        path: "login",
        element: <UserPublicRoute component={UserLogin} />,
      },
      {
        path: "forget-password",
        element: <UserPublicRoute component={ForgetPassword} />,
      },
      {
        path: "reset-password",
        element: <UserPublicRoute component={ResetPassword} />,
      },
      {
        path: "sign-up",
        element: <UserPublicRoute component={UserSignUp} />,
      },
      {
        path: "profile-setup",
        element: <UserPublicRoute component={ProfileSetup} />,
      },
    ],
  },

  // after login
  {
    path: "user",
    element: <UserPrivateRoute component={UserLayout} />,
    children: [
      {
        path: "",
        element: <UserPrivateRoute component={UserDashborad} />,
      },
      {
        path: "search",
        element: <UserPrivateRoute component={Search} />,
      },
      {
        path: "notifications",
        element: <UserPrivateRoute component={Notifications} />,
      },
      {
        path: "horoscope",
        element: <UserPrivateRoute component={Horoscope} />,
      },
      {
        path: "numerology",
        element: <UserPrivateRoute component={Numerology} />,
      },
      {
        path: "kundli-matching",
        element: <UserPrivateRoute component={KundliMatching} />,
      },
      {
        path: "kundli-matching-detail",
        element: <UserPrivateRoute component={KundliMatchingDetail} />,
      },
      {
        path: "my-kundli",
        element: <UserPrivateRoute component={MyKundli} />,
      },

      { path: "*", element: <Page404 /> },
    ],
  },

  /** user auth end */

  /**ADMIN ROUTE START */
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/admin/dashboard"} />,
      },
      {
        path: "live-consultation-monitor",
        element: <PrivateRoute component={LiveConsultationMonitor} />,
      },
      {
        path: "dashboard",
        element: <PrivateRoute component={Dashboard} />,
      },
      {
        path: "revenue",
        element: <PrivateRoute component={RevenueDashboard} />,
      },
      {
        path: "analytics-reports",
        element: <PrivateRoute component={ReportsAnalytics} />,
      },
      {
        path: "invoice-design",
        element: <PrivateRoute component={InvoiceDesign} />,
      },
      {
        path: "profile",
        // element: <Profile />,
        element: <PrivateRoute component={Profile} />,
        children: [
          {
            path: "edit/:id",
            // element: <EditProfile />,
            element: <PrivateRoute component={EditProfile} />,
          },
          {
            path: "change-password/:id",
            // element: <Changepassword />,
            element: <PrivateRoute component={Changepassword} />,
          },
        ],
      },
      {
        /** astrologer User management route start */
      },
      {
        path: "astrologer-management/astrologer/list/:pgno",
        element: <AstrologerUserTable />,
      },
      {
        path: "astrologer-management/astrologer/view/:id",
        element: <AstrologerView />,
      },
      {
        path: "astrologer-management/astrologer/add",
        element: <AstrologerAdd />,
      },
      {
        path: "astrologer-management/astrologer/:pgno/edit/:id",
        element: <AstrologerEdit />,
      },
      {
        path: "astrologer-management/astrologer/call-logs/:id/:pgno",
        element: <CallLogsPage />,
      },
      {
        /** astrologer User management route end */
      },

      {
        /**  User management route start */
      },
      {
        path: "user-management/user/list/:pgno",
        element: <UserTable />,
      },
      {
        path: "user-management/user/view/:id",
        element: <UserView />,
      },
      {
        path: "user-management/user/:pgno/edit/:id",
        element: <UserEdit />,
      },
      {
        path: "user-management/user/add",
        element: <UserAdd />,
      },
      {
        /** User management route end */
      },

      {
        /**contact-us route start */
      },
      {
        path: "contact-us/list/:pgno",
        element: <PrivateRoute component={ContactUsTable} />,
      },
      {
        path: "contact-us/view/:id",
        element: <PrivateRoute component={ViewContactUs} />,
      },
      {
        /**contact-us route end */
      },

      /* remedies management route start */
      {
        path: "remedies-management/remedies/list/:pgno",
        element: <PrivateRoute component={RemedyList} />,
      },
      {
        path: "remedies-management/remedies/view/:id",
        element: <PrivateRoute component={ViewRemedy} />,
      },
      {
        path: "remedies-management/remedies/add",
        element: <PrivateRoute component={AddRemedy} />,
      },
      {
        path: "remedies-management/remedies/edit/:id",
        element: <PrivateRoute component={EditRemedy} />,
      },
      /* remedies management route end */

      /* feedback management route start */
      {
        path: "feedback/list/:pgno",
        element: <PrivateRoute component={FeedbackTable} />,
      },
      {
        path: "feedback/view/:id",
        element: <PrivateRoute component={FeedbackView} />,
      },
      /* feedback management route end */

      /* booking management route start */
      {
        path: "consultation/list/:pgno",
        element: <PrivateRoute component={BookingTable} />,
      },
      // {
      //   path: "booking/view/:id",
      //   element: <PrivateRoute component={BookingView} />,
      // },
      /* booking management route end */

      {
        path: "cms/services/list/:pgno",
        element: <PrivateRoute component={ServiceTable} />,
      },
      {
        path: "cms/service-offer/add",
        element: <PrivateRoute component={OfferManagementAdd} />,
      },

      // Inquiry

      {
        path: "inquiry/list/:pgno",
        element: <PrivateRoute component={InquiryTable} />,
      },
      {
        path: "inquiry/view/:id",
        element: <PrivateRoute component={ViewInquiry} />,
      },

      // Inquiry

      // Learn hub section start
      {
        path: "cms/learn-hub/list/:pgno",
        element: (
          <PrivateRoute component={ListLearnHub} requiredPermission="video" />
        ),
      },
      {
        path: "cms/learn-hub/add",
        element: (
          <PrivateRoute component={AddLearnHub} requiredPermission="video" />
        ),
      },
      {
        path: "cms/learn-hub/:pgno/edit/:id",
        element: (
          <PrivateRoute component={EditLearnHub} requiredPermission="video" />
        ),
      },
      {
        path: "cms/learn-hub/view/:id",
        element: (
          <PrivateRoute component={ViewLearnHub} requiredPermission="video" />
        ),
      },
      // Learn hub section end

      // Pages start

      {
        path: "cms/pages/list/:pgno",
        element: <PrivateRoute component={PageTable} />,
      },
      {
        path: "cms/pages/add",
        element: <PrivateRoute component={PageAdd} />,
      },
      {
        path: "cms/pages/:pgno/edit/:id",
        element: <PrivateRoute component={PageEdit} />,
      },
      {
        path: "cms/pages/view/:id",
        element: <PrivateRoute component={PageView} />,
      },

      // Services

      {
        path: "cms/services/list/:pgno",
        element: <PrivateRoute component={ServiceTable} />,
      },
      {
        path: "cms/services/add",
        element: <PrivateRoute component={ServiceAdd} />,
      },
      {
        path: "cms/services/:pgno/edit/:id",
        element: <PrivateRoute component={ServiceEdit} />,
      },
      {
        path: "cms/services/view/:id",
        element: <PrivateRoute component={ServiceView} />,
      },

      // Languages

      {
        path: "cms/languages/list/:pgno",
        element: <PrivateRoute component={LanguageTable} />,
      },
      {
        path: "cms/languages/add",
        element: <PrivateRoute component={LanguageAdd} />,
      },
      {
        path: "cms/languages/:pgno/edit/:id",
        element: <PrivateRoute component={LanguageEdit} />,
      },
      {
        path: "cms/languages/view/:id",
        element: <PrivateRoute component={LanguageView} />,
      },

      // About Us

      {
        path: "cms/about-us",
        element: <PrivateRoute component={AboutUsAdd} />,
      },

      // cms home

      {
        path: "cms/web-home",
        element: <PrivateRoute component={WebsiteHomeAdd} />,
      },

      // FAQ

      {
        path: "cms/faq/list/:pgno",
        element: <PrivateRoute component={FAQTable} />,
      },
      {
        path: "cms/faq/add",
        element: <PrivateRoute component={FAQAdd} />,
      },
      {
        path: "cms/faq/:pgno/edit/:id",
        element: <PrivateRoute component={FAQEdit} />,
      },
      {
        path: "cms/faq/view/:id",
        element: <PrivateRoute component={FAQView} />,
      },

      {
        path: "cms/settings",
        element: <PrivateRoute component={GlobalSettings} />,
      },

      {
        path: "cms/default-email-template/list/:pgno",
        element: <PrivateRoute component={EmailTemplatesTable} />,
      },
      {
        path: "cms/default-email-template/add",
        element: <PrivateRoute component={EmailTempAdd} />,
      },
      {
        path: "cms/default-email-template/:pgno/edit/:id",
        element: <PrivateRoute component={EmailTempEdit} />,
      },
      {
        path: "cms/default-email-template/view/:id",
        element: <PrivateRoute component={ViewEmailTemp} />,
      },

      /** Email Logs Routing End*/
      {
        path: "cms/email-announcement",
        element: <PrivateRoute component={AdminEmailAnnouncement} />,
      },
      {
        path: "cms/notification-announcement",
        element: <PrivateRoute component={AdminNotificationAnnouncement} />,
      },

      // withdrawal management start

      { path: "withdrawal/list/:pgno", element: <WithdrawalList /> },

      // withdrawal management end

      // order management start

      { path: "order/list/:pgno", element: <OrderList /> },

      { path: "order/view/:id", element: <OrderView /> },

      // order management end

      // puja booking management start

      { path: "puja-booking/list/:pgno", element: <PujaBookingsList /> },
      { path: "puja-booking/list1/:pgno", element: <PujaBookingsList1 /> },

      // puja booking management end

      // Subscription features

      {
        path: "subscription/subscription-feature",
        element: <PrivateRoute component={SubscriptionFeature} />,
      },

      // Subscription benefit
      {
        path: "subscription/subscription-benefit",
        element: <PrivateRoute component={SubscriptionBenefit} />,
      },

      // plan
      {
        path: "subscription/subscription-plan/list/:pgno",
        element: <PrivateRoute component={SubscriptionPlanTable} />,
      },
      {
        path: "subscription/subscription-plan/add",
        element: <PrivateRoute component={AddSubscriptionPlan} />,
      },
      {
        path: "subscription/subscription-plan/edit/:id",
        element: <PrivateRoute component={EditSubscriptionPlan} />,
      },
      {
        path: "subscription/subscription-plan/view/:id",
        element: <PrivateRoute component={SubscriptionPlanView} />,
      },
      //chat interface route end
      {
        path: "chat-support",
        element: <PrivateRoute component={ChatInterface} />,
      },
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:email",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },

  { path: "admin/*", element: <Error404 /> },
  { path: "*", element: <Public404 /> },
]);

export default router;
